module.exports = __webpack_public_path__ + "static/media/ChaloMenu 4.90776f64.jpg";